import { useContext } from "react";
import { useAuthUser } from "react-auth-kit";
import { buildGetOptions, fetchWithErrorHandling } from "services/FetchUtils";
import { AppContext } from "utils/AppContext";
import { getBaseURL } from "utils/Environment";

export const listStreams = async (accessToken: string, baseURL: string, environmentName: string) => {
  return fetchWithErrorHandling(baseURL + `v1/registry/environment/logs/${environmentName}`, buildGetOptions(accessToken));
};
export const listEventLogs = async (accessToken: string, baseURL: string, environmentName: string, streamName: string) => {
  return fetchWithErrorHandling(
    baseURL + `v1/registry/environment/logs/${environmentName}/${streamName}`,
    buildGetOptions(accessToken),
  );
};

export const getEnvVariables = async (accessToken: string, baseURL: string) => {
  return fetchWithErrorHandling(baseURL + "v1/registry/environment/env-variables", buildGetOptions(accessToken));
};

export const useEnvironmentService = () => {
  const authUser = useAuthUser();
  const accessToken = authUser()?.access_token;
  const appContext = useContext(AppContext);

  return {
    listStreams: (environmentName: string) => listStreams(accessToken, getBaseURL(appContext), environmentName),
    listEventLogs: (environmentName: string, streamName: string) =>
      listEventLogs(accessToken, getBaseURL(appContext), environmentName, streamName),
    getEnvVariables: () => getEnvVariables(accessToken, getBaseURL(appContext)),
  };
};
